// extracted by mini-css-extract-plugin
module.exports = {"page-header":"PageHeader_page-header__BK1lb","navbar":"PageHeader_navbar__Nzf3Z"};